export default "__VITE_ASSET__276e80aa__"